import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 26,
	viewBox: "0 0 23 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.96069 20.067L0.211688 12.372L7.98769 4.65L9.63469 6.297L4.77469 11.103H17.7077V13.641H4.77469L9.60769 18.42L7.96069",
		fill: "#1D1D1D"
	})
});
export default SvgArrowLeft2;
